import {
    Control,
    Controller,
    FieldValues,
    UseFormRegister
} from 'react-hook-form'
import { NotificationType } from 'types/notification'

interface RiskEventRadioProps {
    notification: NotificationType
    errors: any
    inputClassNames?: string
    register: UseFormRegister<FieldValues>
    readOnly?: boolean
}

export const RiskEventRadio = ({
    register,
    notification,
    errors,
    inputClassNames,
    readOnly
}: RiskEventRadioProps) => {
    return (
        <fieldset className={`relative 'pointer-events-auto`}>
            <legend className="font-semibold text-xs text-darkGray">
                Evento com Risco de Imagem?
            </legend>
            <div className="flex items-center gap-2">
                <input
                    {...register('u_image_risk')}
                    className={`text-yellow ${inputClassNames}`}
                    type="radio"
                    id="no"
                    value="u_image_risk_no"
                    readOnly={readOnly}
                    disabled={readOnly}
                    defaultChecked={
                        notification?.u_image_risk?.value === 'u_image_risk_no'
                    }
                />

                <label className="text-sm" htmlFor="no">
                    Não
                </label>
            </div>

            <div className="flex items-center gap-2">
                <input
                    {...register('u_image_risk')}
                    className={`text-yellow ${inputClassNames}`}
                    type="radio"
                    id="Sim"
                    value="u_image_risk_yes"
                    readOnly={readOnly}
                    disabled={readOnly}
                    defaultChecked={
                        notification?.u_image_risk?.value === 'u_image_risk_yes'
                    }
                />

                <label className="text-sm" htmlFor="Sim">
                    Sim
                </label>
            </div>

            {readOnly && 
            (<input
                type="hidden"
                value={notification?.u_image_risk?.value}
                {...register('u_image_risk')}
            />)}
          
            {errors && (
                <span className="text-errorText text-xs font-normal absolute">
                    Preenchimento obrigatório
                </span>
            )}
        </fieldset>
    )
}
